import React from "react";
class NotAccessible extends React.Component {
  render() {
    return <b>This page is Not Accessible</b>;
  }
}

export default NotAccessible;
